import { GlobalState } from 'ha/types/store';

export const getLocation = (state: GlobalState) => state.search.map.location;

export const getUniId = (state: GlobalState) => state.search.map.uniID;

export const getCityLocalized = (state: GlobalState) =>
  state.search.map.cityLocalized;

export const getCountryLocalized = (state: GlobalState) =>
  state.search.map.countryLocalized;

export const getLatitude = (state: GlobalState) => state.search.map.latitude;

export const getLongitude = (state: GlobalState) => state.search.map.longitude;

export const getZoomLevel = (state: GlobalState) => state.search.map.zoomLevel;

export const getInitialLatitude = (state: GlobalState) =>
  state.search.map.initialLatitude;

export const getInitialLongitude = (state: GlobalState) =>
  state.search.map.initialLongitude;

export const getInitialZoomLevel = (state: GlobalState) =>
  state.search.map.initialZoomLevel;

export const getMinZoomLevel = (state: GlobalState) =>
  state.search.map.minZoomLevel;

export const getBounds = (state: GlobalState) => state.search.map.bounds;

export const getInfoWindowFor = (state: GlobalState) =>
  state.search.map.infoWindowFor;

export const getHighlightedRoomId = (state: GlobalState) =>
  state.search.map.highlightedRoomId;

export const getScrollwheel = (state: GlobalState) =>
  state.search.map.scrollwheel;

export const getIsAutoSearchEnabled = (state: GlobalState) =>
  state.search.map.isAutoSearchEnabled;

export const getIsOutdated = (state: GlobalState) =>
  state.search.map.isOutdated;

export const getIsMobileMapOpen = (state: GlobalState) =>
  state.search.map.isMobileMapOpen;
